export enum Role {
  ADMIN = 'ADMIN',
  PAYMENT_OPS = 'PAYMENT_OPS',
  CARD_USER = 'CARD_USER',
  READ_ONLY = 'READ_ONLY',
}
